/// <amd-module name="Wit/WorkItemModel/Services/IWorkItemEventService" />
import { IVssObservableService, Services, VssObservableService } from "VSS/Platform/Context";
import { IFieldDataDictionary, ILinkInfo } from "Wit/WorkItemDataManager/Contracts";
import { IWorkItem, WorkItemChangeType } from "Wit/WorkItemModel/OM/WorkItemInterfaces";

export interface IWorkItemEventData {
    workItem: IWorkItem;
    change?: WorkItemChangeType;
    changedWorkItemLinks?: ILinkInfo[];
    externalLinkChanged?: boolean;
    firstSave?: boolean;
    changedFields?: IFieldDataDictionary;
    projectChanged?: boolean;
    typeChanged?: boolean;
}

export enum IWorkItemEventType {
    WorkItemErrorUpdated = "WorkItemErrorUpdated",
    WorkItemReset = "WorkItemReset",
    WorkItemSaved = "WorkItemSaved",
    WorkItemUpdated = "WorkItemUpdated",
    WorkItemCommentsUpdated = "WorkItemCommentsUpdated",
    WorkItemTemplateApplied = "WorkItemTemplateApplied"
}

type IWorkItemEvent = keyof typeof IWorkItemEventType;

/**
 * Service used by WorkItem.ts to signal changes in a work item instance to any subscribers.
 */
export interface IWorkItemEventService extends IVssObservableService<IWorkItemEventData, IWorkItemEvent> {
    fireEvent(eventData: IWorkItemEventData, eventType: IWorkItemEventType): void;
}

class WorkItemEventService extends VssObservableService<IWorkItemEventData, IWorkItemEvent> implements IWorkItemEventService {
    public fireEvent(eventData: IWorkItemEventData, eventType: IWorkItemEventType) {
        this._notify(eventData, eventType);
    }
}

const serviceName = "IWorkItemEventService";
Services.add(serviceName, { serviceFactory: WorkItemEventService });